export const CHANGE_QUERY_PARAMS = 'filterAndSearch/CHANGE_QUERY_PARAMS';
export const CHANGE_SERVICE_URLS = 'filterAndSearch/CHANGE_SERVICE_URLS';
export const EXPORT_DATA = 'filterAndEXPORT_DATA/EXPORT_DATA';
export const EXPORT_DATA_FAILURE = 'filterAndEXPORT_DATA/EXPORT_DATA_FAILURE';
export const EXPORT_DATA_SUCCESS = 'filterAndEXPORT_DATA/EXPORT_DATA_SUCCESS';
export const INIT_COMPONENTS = 'filterAndSearch/INIT_COMPONENTS';
export const LOCATION_PARSED = 'filterAndSearch/LOCATION_PARSED';
export const RESET_RELOAD = 'filterAndSearch/RESET_RELOAD';
export const SET_EXPORT_ROWS_LIMIT_REACHED =
  'filterAndSearch/SET_EXPORT_ROWS_LIMIT_REACHED';
export const RESET_QUERY_PARAMS = 'filterAndSearch/RESET_QUERY_PARAMS';
export const SEARCH = 'filterAndSearch/SEARCH';
export const SEARCH_FAILURE = 'filterAndSearch/SEARCH_FAILURE';
export const SEARCH_SUCCESS = 'filterAndSearch/SEARCH_SUCCESS';
export const SET_DYNAMIC_RESULT_ITEMS =
  'filterAndSearch/SET_DYNAMIC_RESULT_ITEMS';
export const TOGGLE_LOADED = 'filterAndSearch/TOGGLE_LOADED';
